var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb71(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7905 12.2651L10.2181 5.12452C9.32584 2.64766 8.8797 1.40923 7.87691 0.70462C6.87413 0 5.55779 0 2.9251 0H0V17.5192H6.20149V6.67144L10.0774 17.5192H15.5037L19.3796 6.67144V17.5192H25.5812V0H22.656C20.0233 0 18.707 0 17.7043 0.70462C16.7015 1.40923 16.2553 2.64766 15.363 5.12452L12.7905 12.2651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2457 12.2651L39.6733 5.12452C38.7809 2.64766 38.3347 1.40923 37.332 0.70462C36.3292 0 35.0129 0 32.3801 0H29.4551V17.5192H35.6565V6.67144L39.5324 17.5192H44.9588L48.8348 6.67144V17.5192H55.0362V0H52.1112C49.4784 0 48.162 0 47.1593 0.70462C46.1566 1.40923 45.7104 2.64766 44.8181 5.12452L42.2457 12.2651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.395H25.5812V26.8212H6.20149C6.20149 27.2532 6.20149 28.7093 6.21583 28.8916C6.39534 31.1723 8.20689 32.9839 10.4877 33.1635C10.6699 33.1778 10.8858 33.1778 11.3177 33.1778H25.5812V38.9141H17.5193C11.2948 38.9141 8.18266 38.9141 5.81745 37.6754C3.86085 36.6507 2.2635 35.0533 1.23875 33.0967C0 30.7315 0 27.6193 0 21.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6039 30.1552C49.6039 26.9769 46.1931 25.2715 42.2396 25.2715C38.2861 25.2715 34.8753 26.9769 34.8753 30.1552C34.8753 33.3334 38.2861 35.0389 42.2396 35.0389C46.1931 35.0389 49.6039 33.3334 49.6039 30.1552ZM42.2396 40C50.379 40 55.8053 35.8141 55.8053 30.1552C55.8053 24.4964 50.379 20.3103 42.2396 20.3103C34.1001 20.3103 28.6738 24.4964 28.6738 30.1552C28.6738 35.8141 34.1001 40 42.2396 40Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb71);
export default __webpack_public_path__ + "static/media/ab (7.1).f0117034e8869c42a4db85e8081ef9eb.svg";
export { ForwardRef as ReactComponent };